import { BackIcon } from "./icons";

function ProductHeader({ onBack, showBack = false }) {
  return (
    <header className="photo-select-header">
      {showBack ? (
        <button
          aria-label="이전 화면으로 이동"
          className="photo-select-back-button"
          onClick={onBack}
          type="button"
        >
          <BackIcon />
        </button>
      ) : null}
      <h1>제품 신청</h1>
    </header>
  );
}

export { ProductHeader };
